export default __webpack_public_path__ + "static/media/female_idle_lod.3ac2e0f2.glb";